import { Vue } from 'vue-facing-decorator';

export default class VentlaClassicHelper extends Vue{
  // Latest start date allowed for events created on Ventla Classic
  public static MaxStartDate = '2026-12-31T23:59:59.999Z';
  // Events created on/after this release date keep the start date cap when edited later
  public static CapReleaseDate = '2026-10-25T00:00:00.000Z';
}
